export const LANGUAGE_EN = 'en';

export const LANGUAGES = [LANGUAGE_EN];

export const LANGUAGE_LABELS: { [key: string]: string } = {
    [LANGUAGE_EN]: 'ENG'
};

export const DEFAULT_LANGUAGE = LANGUAGE_EN;
